module.exports = __webpack_public_path__ + "static/media/Donuts.6ceb1762.svg";